import ContainerWrapper from "@Components/generic/container-wrapper";
import { Container, Stack, SxProps, Typography, useTheme } from "@mui/material";

interface IAccountPageLayout {
  title: string;
  subtitle?: string;
  pageId: string;
  children: React.ReactNode;
  description?: string;
  centered?: boolean;
  sx?: SxProps;
}

const AccountPageLayout = ({ children, title, subtitle, description, centered, pageId, sx }: IAccountPageLayout) => {
  const theme = useTheme();

  return (
    <ContainerWrapper id={pageId} sx={{ overflow: "visible" }}>
      <Container maxWidth={false} sx={{ textAlign: "center", paddingTop: theme.spacing(centered ? 16 : 0), height: "100%" }}>
        <Stack sx={{ pb: 10, boxSizing: "border-box", ...sx }}>
          <Typography variant="text4xl700" color="dsBase.v200">
            {title}
          </Typography>

          {subtitle && (
            <Typography variant="text1xl500" color="dsBase.v200" sx={{ mt: 1, mb: 1 }}>
              {subtitle}
            </Typography>
          )}

          {description && (
            <Typography variant="text1xl500" color="dsNeutral.v300" sx={{ mt: 1, mb: 3 }}>
              {description}
            </Typography>
          )}

          {children}
        </Stack>
      </Container>
    </ContainerWrapper>
  );
};

export default AccountPageLayout;
